import { RouteGuard } from "@/components/auth/route-guard";
import Profile from "@/components/shared/profile";
import { Separator } from "@/components/ui/separator";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/features/dashboard/components/app-sidebar";
import AppTour from "@/features/dashboard/components/app-tour";
import { Notifications } from "@/features/dashboard/components/notifications";
import { HistoryProvider } from "@/providers/history.provider";
import { createFileRoute, Outlet } from "@tanstack/react-router";

function DashboardLayout() {
  return (
    <RouteGuard>
      <HistoryProvider>
        <SidebarProvider>
          <AppSidebar />
          <main className="w-full">
            <header className="flex h-14 shrink-0 items-center gap-2">
              <div className="flex flex-1 items-center gap-2 px-3">
                <SidebarTrigger />
                <Separator orientation="vertical" className="mr-2 h-4" />
              </div>
              <div className="ml-auto px-3 flex items-center gap-3.5">
                <Notifications />
                <AppTour />
                <Profile />
              </div>
            </header>
            <Outlet />
          </main>
        </SidebarProvider>
      </HistoryProvider>
    </RouteGuard>
  );
}

export const Route = createFileRoute("/(app)/dashboard")({
  component: DashboardLayout,
});
